import {
  ASSET_MODAL_RIGHT_PANEL_OPEN_TABS,
  type AssetModalRightPanelOpenTab,
} from '~/components/AssetModalV2/assetModalRightPanelTabs';
import { QueryParamNames } from '~/constants/search';

export const parseAssetModalRightPanelTabFromRouterAsPath = (asPath: string): AssetModalRightPanelOpenTab | null => {
  const withoutHash = asPath.split('#')[0];
  const searchIndex = withoutHash.indexOf('?');
  const search = searchIndex >= 0 ? withoutHash.slice(searchIndex) : '';
  const rightPanelTab = new URLSearchParams(search).get(QueryParamNames.amTab);

  return ASSET_MODAL_RIGHT_PANEL_OPEN_TABS.find((openTab) => openTab === rightPanelTab?.toLowerCase()) ?? null;
};
